import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const CartsAndKiosks = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/Carts&Kiosks/pointOfSale.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Point of Sale Billing",
            desc: "A Point of Sale solution developed and customized for carts and kiosks vendors. Enable faster checkout with a user-friendly interface that allows customers to easily scan items and complete purchases using QB software.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Intuitive interface designed for quick adoption by shop owners and staff.
                </>,
                <>
                    Reduces waiting time and long queues at the checkout counter.
                </>,
                <>
                    Seamless integration with barcode scanners for accurate billing.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/Carts&Kiosks/inventory.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Inventory Management",
            desc: "Managing inventory is the biggest challenge for businesses of all sizes. Knowing how much stock is in-store, in production, and tracking expiring products can be difficult—especially when managing multiple carts and kiosks. QueueBuster POS offers a seamless inventory management solution.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Monitor stock levels across multiple kiosks from a single platform.

                </>,
                <>
                    Receive low-stock alerts to restock popular items before they run out.
                </>,
                <>
                    Synchronize inventory data with your sales to avoid discrepancies.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/Carts&Kiosks/vendor.webp",
            tag: "Vendor Management",
            icon: "/assets/outlet/iceCreamOutlet/vendorIcon.svg",
            title: "Online & Offline Mode Billing",
            desc: "This is a common requirement for businesses that need offline billing solutions. Sometimes the internet may go down, and sales records could be lost. Offline billing solutions are critical in such situations, and this is one of our USPs. Most software companies do not offer this feature.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                   Remain operational during internet outages with full offline capabilities.

                </>,
                <>
                    Sync sales and other data effortlessly when the connection is restored.
                </>,
                <>
                    Ensure consistent sales and customer satisfaction.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/Carts&Kiosks/onlineStore.webp",
            tag: "Online Stores",
            icon: "/assets/outlet/iceCreamOutlet/estoreIcon.svg",
            title: "Reduces checkout time with faster and secure payment processing",
            desc: "Accept payments via cash, card, UPI, or digital wallets, offering your customers flexible payment methods to enhance their shopping experience.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Supports all popular payment methods for greater convenience.

                </>,
                <>
                    Streamlines transactions with integrated payment gateways.
                </>,
                <>
                    Reduces checkout time with faster, secure payment processing.
                </>,
            ],
        },
        
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster help reduce billing time at kiosks?
                </span>
            ),
            des: "QueueBuster’s POS software provides an easy-to-use interface, barcode scanning, and multiple payment options to ensure faster billing, reducing long queues and enhancing customer satisfaction.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can QueueBuster POS be integrated with my existing apps and software?
                </span>
            ),
            des: "Yes, QueueBuster POS can seamlessly integrate with your existing software and apps such as CRM, payments, e commerce marketplaces, ADSR and many more.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What types of payment methods does QueueBuster support?

                </span>
            ),
            des: "QueueBuster POS supports a variety of payment methods, including cash, credit/debit cards, UPI, mobile wallets, and many more, providing convenience to your customers.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Is my data safe with QueueBuster POS?
                </span>
            ),
            des: "Absolutely! QueueBuster POS uses secure cloud backups and provides role-based access to ensure your business data is protected at all times.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Does QueueBuster POS work offline?
                </span>
            ),
            des: "Yes, QueueBuster POS continues to function even when the internet is down. All sales and transactions are synced once the connection is restored.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How customizable is the software for different retail environments?
                </span>
            ),
            des: " QueueBuster POS is highly customizable, allowing you to tailor the system to meet the specific needs of your carts or kiosks, from report generation to customer engagement features.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Do I need a separate pos software for each kiosk?
                </span>
            ),
            des: "No, QueueBuster POS is designed to be scalable, so you can manage multiple kiosks from a single pos software, ensuring smooth operations across different points of sale.",
            id: 7,
            activeIndex: 0,
        },
       
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/Carts&Kiosks/mobileCarts&Kiosks.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Billing Software for</span><span></span>
                                <span>&nbsp; Carts & Kiosks</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Effortlessly manage your retail operations with QueueBuster’s innovative billing software, designed specifically for carts and kiosks. Use it on your smartphone or any Android payment machine, saving valuable shelf space—no need for bulky POS machines.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/Carts&Kiosks/Carts&Kiosks.webp"
                            heading={<>POS Billing Software <br />for</>}
                            staticHeading={<> Carts & Kiosks</>}
                            description={"Effortlessly manage your retail operations with QueueBuster’s innovative billing software, designed specifically for carts and kiosks. Use it on your smartphone or any Android payment machine, saving valuable shelf space—no need for bulky POS machines."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "63%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Key Features for Carts & Kiosks Management Software</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions of Pharmacy POS System"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions of Pharmacy POS System"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default CartsAndKiosks
 